import React from "react";
import { cn } from "@/lib/utils";

interface CatalogHeroDotsProps {
  count: number;
  activeIndex: number;
  onDotClick: (index: number) => void;
}

export default function CatalogHeroDots({
  count,
  activeIndex,
  onDotClick,
}: CatalogHeroDotsProps) {
  if (count <= 1) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: count }).map((_, index) => (
        <button
          aria-label={`Go to slide ${index + 1}`}
          className={cn(
            "h-2 rounded-full transition-all duration-300",
            index === activeIndex
              ? "w-8 bg-white"
              : "w-2 bg-white/40 hover:bg-white/60",
          )}
          key={index}
          onClick={() => onDotClick(index)}
          type="button"
        />
      ))}
    </div>
  );
}
